import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0f527e6d&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f527e6d')) {
      api.createRecord('0f527e6d', component.options)
    } else {
      api.reload('0f527e6d', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=0f527e6d&", function () {
      api.rerender('0f527e6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J6W0v6xZznwA/JS/comp/ErrorMessage.vue"
export default component.exports